import React, { useCallback, useMemo } from 'react'
import RequireAuth from './RequireAuth';
import useKiponosNavigator, { getPage } from '../../hooks/useKiponosNavigator';
import './NavLink.css'

const NavLink = ({pageKey, customTitle, withActiveStyle = true}) => {
  const {navTo, getStyle} = useKiponosNavigator();
  const page = useMemo( () => getPage(pageKey), [pageKey]);
  
  // ---  On Click  ---
  //
  const onClick = useCallback(() => {
    navTo(pageKey);
  }, [navTo, pageKey]);

  //  ---  Get LinkButton  ---
  //
  const getLinkButton = useCallback(() => {
    const style = withActiveStyle ? getStyle(pageKey) : 'navLink';
    const icon = page ? <page.icon /> : '';
    const title = customTitle ? customTitle : page?.title ? page.title : '?';
    const isBeta = page?.isBeta;

    // Add the "beta" tag if needed
    const betaTag = isBeta ? <span className='betaTag'>Beta</span> : '';    

    return <div className={style} onClick={onClick}>
              <div className='navLinkTitle'>
                {icon} {title} 
              </div>
              {isBeta &&
                <div className='navLinkBetaTag'>
                  {betaTag}
                </div>}
           </div>
  }, [getStyle, onClick, page, pageKey, withActiveStyle, customTitle]);

  //  ---  As Auth LinkButton  ---
  //
  const asAuthLinkButton = useCallback((linkButton) => {
    return <RequireAuth>{linkButton}</RequireAuth>
  }, []);

  // ------  Render  ------

  const linkButton = useCallback( () => getLinkButton(), [getLinkButton]);
  const buttonCompFn = useCallback( () => page.auth ? asAuthLinkButton(linkButton()) : linkButton(), [asAuthLinkButton, linkButton, page.auth]);
  const buttonComp = buttonCompFn();

  const styleClass = `navLinkWrapper ${page.isSub ? 'subMenuItem' : ''}`;

  return ( 
    <div className={styleClass}>
      {buttonComp}
    </div>
  )
}

export default React.memo(NavLink);